import { useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import { chooseProfileFilter } from '../../../../helpers/chooseProfileFilter';

export const useUserCity = () => {
    const profileFilter = chooseProfileFilter();

    
    return useQuery({
        queryKey: ['city'],
        queryFn: async () => {
            return await Fetch.post(
                config.endpoints.backend +
                    'governanceroom/clientscities/getById',
                {
                    id: profileFilter.governance_room_client_city_id
                }
            );
        },
        enabled: !!profileFilter.governance_room_client_city_id,
        staleTime: Infinity
    });
};
